import { FelaCSS } from '@bridebook/ui';
import { buildImageSrc } from '@bridebook/toolbox/src/buildImageUrl';

interface IStyles {
  photo: (url: string) => FelaCSS;
}

const styles: IStyles = {
  photo: (url: string) => ({
    backgroundImage: `url(${buildImageSrc(url, {
      w: 480,
      h: 375,
      dpr: 2,
      gravity: 'face',
      fit: 'cover',
    })})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    minHeight: 375,
    minWidth: 'auto',
    width: '100%',

    '@container (width > 768px)': {
      minHeight: '-webkit-fill-available',
      backgroundImage: `url(${buildImageSrc(url, {
        w: 500,
        h: 500,
        dpr: 2,
        gravity: 'face',
        fit: 'cover',
      })})`,
    },
  }),
};

export default styles;
